import { useState, useEffect } from 'react';
import { useInterval } from 'src/hooks/useInterval';
import * as LanternApi from 'src/utilities/LanternApiClient';
import { ALERTS_REFRESH_INTERVAL } from 'src/constants';

export const useAlerts = (isAuthenticated) => {
  const [alerts, setAlerts] = useState([]);
  const [archivedAlerts, setArchivedAlerts] = useState([]);
  const [isArchiving, setIsArchiving] = useState(false);

  const getUserAlerts = async () => {
    const response = await LanternApi.getUserAlerts();
    if (response?.success) {
      setAlerts(response.body.filter((a) => a.isArchived === false));
      setArchivedAlerts(response.body.filter((a) => a.isArchived === true));
    }
  };

  useInterval(getUserAlerts, ALERTS_REFRESH_INTERVAL);

  useEffect(() => {
    if (isAuthenticated) getUserAlerts();
  }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  const archiveAlert = async (id, allUsers) => {
    setIsArchiving(true);
    try {
      const resp = allUsers ? await LanternApi.archiveAlertForAllUsers(id) : await LanternApi.archiveAlert(id);
      if (resp?.success) {
        let archivedAlert = null;
        setAlerts((prevAlerts) => {
          archivedAlert = prevAlerts.find((x) => x.id === id);
          if (allUsers && archivedAlert) {
            archivedAlert.archiveForAllUsers = true;
          }
          return prevAlerts.filter((x) => x.id !== id);
        });
        if (archivedAlert) {
          setArchivedAlerts((prevArchived) => [...prevArchived, archivedAlert]);
        }
      }
    } finally {
      setIsArchiving(false);
    }
  };

  const unarchiveAlert = async (id) => {
    setIsArchiving(true);
    try {
      const resp = await LanternApi.unarchiveAlert(id);
      if (resp?.success) {
        let unarchivedAlert = null;
        setArchivedAlerts((prevArchived) => {
          unarchivedAlert = prevArchived.find((x) => x.id === id);
          return prevArchived.filter((x) => x.id !== id);
        });
        if (unarchivedAlert) {
          setAlerts((prevAlerts) => [...prevAlerts, unarchivedAlert]);
        }
      }
    } finally {
      setIsArchiving(false);
    }
  };

  return {
    alerts,
    archivedAlerts,
    archiveAlert,
    unarchiveAlert,
    isArchiving,
  };
};
